import { connect } from "react-redux";
import { useState } from "react";
import TaxHarvestingGeneralSearch from "./TaxHarvestingGeneralSearch";
import TaxHarvestingCards from "./TaxHarvestingCards";
import TaxHarvestingResults from "./taxHarvestingResults/TaxHarvestingResults";

function TaxHarvesting(props) {
  const [snapshot, setSnapshot] = useState(null);
  const [lots, setLots] = useState({});

  return (
    <div className="c-tax-harvesting">
      <TaxHarvestingGeneralSearch setSnapshot={setSnapshot} setLots={setLots}  />
      { snapshot && (
        <>
          <TaxHarvestingCards snapshot={snapshot} />
        </>
      )}
      { snapshot && Object.values(lots).length > 0 && (
        <>
          <TaxHarvestingResults snapshot={snapshot} lots={lots} />
        </>
      )}

    </div>
  );
}

function mapStateToProps(state) {
  return {
    user: state.session.user,
    authentication_token: state.session.authentication_token,
    blur_active: state.session.blur_active    
  };
}

function mapDispatchToProps(dispatch) {
  return {
    // getDashboard: (authentication_token, success, error) =>
    //   dispatch(getDashboard(authentication_token, success, error)),
    // setDefaultRedirection: (authentication_token, success, error) =>
    //   dispatch(setDefaultRedirection(authentication_token, success, error)),
    // updateUser: (authentication_token, attributes, success, error) =>
    // dispatch(updateUser(authentication_token, attributes, success, error)),

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TaxHarvesting);
